/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Document type
 */
export enum FinnairBoardingPassDocumentType {
  PDF = 'PDF',
  PDF_V_2 = 'PDF_V2',
  PDF_V_2_JSON = 'PDF_V2_JSON',
  APPLE_WALLET = 'APPLE_WALLET',
  APPLE_WALLET_V_2 = 'APPLE_WALLET_V2',
  GOOGLE_WALLET = 'GOOGLE_WALLET',
  GOOGLE_WALLET_V_2 = 'GOOGLE_WALLET_V2',
  GOOGLE_WALLET_V_2_JSON = 'GOOGLE_WALLET_V2_JSON',
  RAW_DATA = 'RAW_DATA'
}

